var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#474747;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 12,
    height: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    className: "st0",
    width: 12,
    height: 12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    className: "st0",
    width: 12,
    height: 12
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    className: "st0",
    width: 12,
    height: 12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    className: "st0",
    width: 12,
    height: 12
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 60 -48)",
    className: "st0",
    width: 12,
    height: 12
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 12,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 60 -24)",
    className: "st0",
    width: 12,
    height: 12
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 36,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 60 24)",
    className: "st0",
    width: 12,
    height: 12
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 48,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 60 48)",
    className: "st0",
    width: 12,
    height: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXGray);
export default __webpack_public_path__ + "static/media/x_gray.508a2dfb27a3336f9e1295d40c22020e.svg";
export { ForwardRef as ReactComponent };